import Box from '@liquidweb-dev/undercurrent/Box';
import Card, { type CardProps } from '@liquidweb-dev/undercurrent/Card';
import CardContent from '@liquidweb-dev/undercurrent/CardContent';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import Stack from '@liquidweb-dev/undercurrent/Stack';

const SkeletonCardItem = (props: CardProps) => (
	<Card {...props}>
		<CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 200 }}>
			<Box sx={{ display: 'flex', gap: 200, alignItems: 'center' }}>
				<Skeleton
					variant="circular"
					sx={({ size }) => ({
						width: size.md,
						height: size.md,
						flexShrink: 0,
					})}
				/>

				<Stack sx={{ gap: 100, width: '100%' }}>
					<Skeleton
						variant="rounded"
						sx={{
							maxWidth: '250px',
							width: '100%',
							height: ({ size }) => size.xXS,
						}}
					/>
					<Skeleton
						variant="rounded"
						sx={{
							maxWidth: '200px',
							width: '100%',
							height: ({ size }) => size.xXS,
						}}
					/>
				</Stack>
			</Box>

			<Skeleton
				variant="rounded"
				sx={{ width: '75%', height: ({ size }) => size.xXS }}
			/>

			<Skeleton
				variant="rounded"
				sx={{ width: '100%', height: ({ size }) => size.xXS }}
			/>
		</CardContent>
	</Card>
);

export default SkeletonCardItem;
